import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false
};

const backOfficeSlice = createSlice({
  name: 'status',
  initialState,
  reducers: {
    setBackOfficeData: (state, action) => {
      state.loading = true;
    },
    setLoading:(state) => {
      state.loading = false;
    }
  }
});

export const { setBackOfficeData, setLoading } = backOfficeSlice.actions;

export default backOfficeSlice.reducer;
